import { createContext, useContext } from 'react';

import type { LEARNING_GOAL_OPTIONS_TYPE } from 'bundles/onboarding-common/constants';
import type { Skill } from 'bundles/onboarding-common/types';

export type OnboardingOptionsContextType = {
  /**
   * The current learning goal
   */
  learningGoal: LEARNING_GOAL_OPTIONS_TYPE | null;
  /**
   * All available skills for selection
   */
  allSkills: Skill[];
  /**
   * Whether skills are loading
   */
  isLoadingSkills: boolean;
  /**
   * Type of skills being displayed (role-based or popular)
   */
  skillsType: 'ROLE_SKILLS' | 'POPULAR_SKILLS';
};

const OnboardingOptionsContext = createContext<OnboardingOptionsContextType | null>(null);

export const useOnboardingOptions = () => {
  const context = useContext(OnboardingOptionsContext);

  if (!context) {
    throw new Error('useOnboardingOptions must be used within a OnboardingOptionsProvider');
  }

  return context;
};

export default OnboardingOptionsContext;
